import { render, staticRenderFns } from "./PromoCode.vue?vue&type=template&id=a18a0cb8&scoped=true&"
import script from "./PromoCode.vue?vue&type=script&lang=js&"
export * from "./PromoCode.vue?vue&type=script&lang=js&"
import style0 from "./PromoCode.vue?vue&type=style&index=0&id=a18a0cb8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18a0cb8",
  null
  
)

export default component.exports